export const CHANNEL_GROOV_PANEL_ID = "ChannelGroovPanelId";
export const CHANNEL_GROOV_BUTTON_DEFAULT_ID = "ChannelGroovButtonDefaultId";
export const CHANNEL_GROOV_BUTTON_HOVERED_ID = "ChannelGroovButtonHoveredId";
